// @ts-ignore
import { getTypeInfo } from "credit-card-type";
import { defaults, pipe, replace, toLower } from "lodash/fp";

import {
  CreditCardBrandCode,
  CreditCardDefinition,
} from "@zapier/payment/esm/types";

const UNKNOWN_CARD: CreditCardDefinition = {
  code: {
    name: "CVV",
    size: 3,
  },
  gaps: [4, 8, 12],
  lengths: [16],
  niceType: "Unknown",
  type: "unknown",
};

export default function getCardDefinitionFromBrand(
  brand: CreditCardBrandCode
): CreditCardDefinition {
  return pipe([
    replace(/ /g, "-"),
    toLower,
    getTypeInfo,
    defaults(UNKNOWN_CARD),
  ])(brand);
}
